module.exports = __webpack_public_path__ + "img/logoname.66ae5db6.png";